export default class UserDataConfigModel {
  public storeIp: boolean = false;
  public storeDeviceId: boolean = false;
  public storeAgent: boolean = false;
}
